import React from "react";

export default function EllipsisIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg
      viewBox="0 0 5 20"
      fill="none"
      style={{ ...filteredStyles, fill: "none" }}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 10.0001C5 11.3599 3.88077 12.4621 2.5 12.4621C1.11923 12.4621 0 11.3599 0 10.0001C0 8.64031 1.11923 7.53809 2.5 7.53809C3.88077 7.53809 5 8.64031 5 10.0001Z"
        fill={filteredStyles.fill}
      />
      <path
        d="M5 2.46201C5 3.82179 3.88077 4.92401 2.5 4.92401C1.11923 4.92401 0 3.82179 0 2.46201C0 1.10222 1.11923 0 2.5 0C3.88077 0 5 1.10222 5 2.46201Z"
        fill={filteredStyles.fill}
      />
      <path
        d="M5 17.5379C5 18.8977 3.88077 19.9999 2.5 19.9999C1.11923 19.9999 0 18.8977 0 17.5379C0 16.1782 1.11923 15.0759 2.5 15.0759C3.88077 15.0759 5 16.1782 5 17.5379Z"
        fill={filteredStyles.fill}
      />
    </svg>
  );
}
